import { create } from "zustand";

const useDragPointsStore = create((set) => ({
  previewPoints: [],
  originalPreviewPoints: [],

  setOriginalPreviewPoints: (points) => set({ originalPreviewPoints: points }),

  setPreviewPoints: (points) =>
    set({
      previewPoints: points.map((p) => ({
        ...p,
        initialLat: p.latitude,
        initialLng: p.longitude,
      })),
    }),

  makeAllDraggable: () =>
    set((state) => ({
      previewPoints: state.previewPoints.map((p) => ({
        ...p,
        draggable: true,
      })),
    })),

  updatePointPosition: (pointId, newPosition) => {
    set((state) => ({
      previewPoints: state.previewPoints.map((p) =>
        p.id === pointId ? { ...p, ...newPosition } : p
      ),
    }));
  },

  resetPreviewPoints: () =>
    set((state) => ({
      previewPoints: state.originalPreviewPoints.map((p) => ({
        ...p,
        initialLat: p.latitude,
        initialLng: p.longitude,
      })),
    })),
}));

export default useDragPointsStore;
